import { createBrowserRouter } from "react-router-dom";
import App from './App';
import Detail from "./Detail";
import List from './List';
import HotSearch from "./HotSearch";
import Increase from "./Increase";
import Particulars from "./Particulars";
import MyFollow from "./MyFollow";
import Code from "./Code";
import Feedback from "./Feedback";

// 函数用于根据 URL 层级动态生成 basename
function getBasename() {
  const pathname = window.location.pathname;
  const pathParts = pathname.split('/').filter(part => part);
  if (pathParts.length >= 1) {
    pathParts.pop();
    return '/' + pathParts.join('/');
  }
  return '/';
}


const basename = '/';//process.env.NODE_ENV === 'development'?'/': getBasename();
const Routes = createBrowserRouter([
  {
    title: "主页",
    path: "/index",
    element: <App />,
  },
  {
    title: "主页",
    path: "/",
    element: <App />,
  },
  {
    title: "详情",
    path: "/detail/:code",
    element: <Detail />,
  },
  {
    title: "列表",
    path: "/:type",
    element: <List />,
  },
  {
    title: "热搜榜",
    path: "/hotsearch",
    element: <HotSearch />,
  },
  {
    title: "增仓榜",
    path: "/increase",
    element: <Increase />,
  },
  {
    title: "个股股东详情",
    path: "/particulars/:code",
    element: <Particulars />,
  },
  {
    title: "我的关注",
    path: "/myfollow",
    element: <MyFollow />,
  },
  {
    title: "登录",
    path: "/code.html",
    element: <Code />,
  },
  {
    title: "意见反馈",
    path: "/feedback",
    element: <Feedback />,
  }
], {
  basename: basename
});

export default Routes;